import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'
import cn from 'classnames'

import lang from 'lang'
import { isUser, replace } from 'common/utils'
import actionLinks from 'common/action-links'

import { completeNudge } from './service/actions'

@connect(
  (state) => ({
    user: state.root.user,
    userStats: _.get(state.school.userStats, 'items.0.people_in_school'),
    school: state.school.details.item,
  }),
  (dispatch) => ({
    completeNudge: (payload) => dispatch(completeNudge(payload)),
  }),
)
export default class NudgeTask extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    school: PropTypes.object,
    task: PropTypes.object,
    nudgeSet: PropTypes.object,
    userStats: PropTypes.object,
    showAction: PropTypes.bool,
    showStats: PropTypes.bool,
    completeNudge: PropTypes.func,
  }

  constructor(props) {
    super(props)
    this.actionLink = React.createRef()
  }

  get totalPeople() {
    return _.get(this.props.userStats, 'enabled')
  }

  completeNudgeHandler() {
    const { id, completed_nudge } = this.props.task
    const isImplementationTeam = isUser.schoolImplementationTeam(this.props.user)
    return () => {
      if (completed_nudge) return
      this.props.completeNudge({
        id,
        nudgeDescription: this.props.task.body,
        nudgeSetId: this.props.nudgeSet.id,
        nudgeSetName: this.props.nudgeSet.title,
        isImplementationTeam,
      })
    }
  }

  replaceLink(input) {
    _.each(actionLinks, ({ action, url }) => {
      input = input.replace(action, url({ school: this.props.school }))
    })
    return input
  }

  render() {
    const { id, body, completed_nudge, completed_my_school } = this.props.task

    let percent = 0
    if (this.totalPeople > 1) {
      percent = (completed_my_school / this.totalPeople) * 100
    }

    const width = { width: `${percent}%` }

    return (
      <li key={id}>
        {this.props.showStats ? (
          <div
            className="progress"
            role="progressbar"
            tabIndex="0"
            aria-valuenow={percent}
            aria-valuemin="0"
            aria-valuetext={`${percent} percent`}
            aria-valuemax="100">
            <div className="progress-meter" style={width} />
          </div>
        ) : null}
        <div className="nudge-task-body">
          {this.props.showStats ? (
            <p className="nudge-task-stats">
              {replace(
                completed_my_school === 1
                  ? lang.dashboard.nudges.personCompleted
                  : lang.dashboard.nudges.peopleCompleted,
                [completed_my_school],
              )}
            </p>
          ) : null}
          <p
            ref={this.actionLink}
            dangerouslySetInnerHTML={{
              __html: this.replaceLink(body),
            }}
          />
        </div>
        {this.props.showAction ? (
          <div className="nudge-task-action">
            <button
              type="button"
              onClick={this.completeNudgeHandler()}
              className={cn('hollow', 'complete', 'button', { done: completed_nudge })}>
              {completed_nudge
                ? lang.dashboard.nudges.completed
                : lang.dashboard.nudges.markCompleted}
            </button>
          </div>
        ) : null}
      </li>
    )
  }
}
